<template>
    <a-button
        type="primary"
        class="back-button"
        :title="title"
        data-test-id="back-btn"
        @click="$emit('click')"
    >
        <template #icon>
            <arrow-left-outlined />
        </template>
        Назад
    </a-button>
</template>

<script>
import ArrowLeftOutlined from '@ant-design/icons-vue/ArrowLeftOutlined';

export default {
    name: 'BackButton',
    components: {
        ArrowLeftOutlined,
    },
    props: {
        title: {
            type: String,
            default: 'Назад',
        },
    },
    emits: ['click'],
};
</script>
